var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4,6h2v2h-2v-2Zm0,12h2v-2h-2v2Zm0-5h2v-2h-2v2Zm4-7v2h12v-2H8Zm0,7h12v-2H8v2Zm0,5h12v-2H8v2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList);
export default __webpack_public_path__ + "static/1768397567/media/icon-list.7ede5eaf85dea4c8ef8096d990d0ecfc.svg";
export { ForwardRef as ReactComponent };